var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.ACTION_TYPE = {
	SAVE: 'SAVE',
	UPDATE: 'UPDATE'
};

Object.freeze(Enum.MEEDY.ACTION_TYPE);